import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { HeaderComponent } from './header.component';
import { LiveAgentSupportComponent } from './live-agent-support/live-agent-support.component';
import { ReferralPageLinkComponent } from './referral-page-link/referral-page-link.component';
import { LoginLogoComponent } from './login-logo/login-logo.component';
import { LiveAgentSupportService } from './live-agent-support/live-agent-support.service';
import { ChatBotButtonComponent } from './chat-bot-button/chat-bot-button.component';
import { ProfileAvatarModule } from '../components/profile-avatar/profile-avatar.component';

@NgModule({
    declarations: [
        HeaderComponent,
        LiveAgentSupportComponent,
        ReferralPageLinkComponent,
        LoginLogoComponent,
        ChatBotButtonComponent,
    ],
    exports: [
        HeaderComponent,
        LoginLogoComponent
    ],
    imports: [
        SharedModule,
        ProfileAvatarModule,
    ],
    providers: [
        LiveAgentSupportService
    ]
})
export class HeaderModule {}



// WEBPACK FOOTER //
// ./ts/app/header/header.module.ts